import React from 'react';

import classes from './Home.module.css';

const Home = (props) => {
  
    return (
      <div className={classes.home}>
        <div className={classes.message}>
          <h2>This is the way</h2>
          <p>Authentic mandalorians following <br /> the path.</p>
        </div>
        <div className={classes['mandalorian-message']}>
          <h3>
            <span>P</span>
            <span>r</span>
            <span>e</span>
            <span>p</span>
            <span>a</span>
            <span>r</span>
            <span>e</span>
            <span> </span>
            <span>y</span>
            <span>o</span>
            <span>u</span>
            <span>r</span>
            <br />
            <span>s</span>
            <span>e</span>
            <span>l</span>
            <span>f</span>
            <span> </span>
            <span>f</span>
            <span>o</span>
            <span>r</span>
            <span> </span>
            <span>t</span>
            <span>h</span>
            <span>e</span>
            <br />
            <span>h</span>
            <span>a</span>
            <span>r</span>
            <span>s</span>
            <span>h</span>
            <span> </span>
            <span>e</span>
            <span>n</span>
            <span>v</span>
            <span>i</span>
            <span>r</span>
            <span>o</span>
            <br />
            <span>n</span>
            <span>m</span>
            <span>e</span>
            <span>n</span>
            <span>t</span>
            <span> </span>
            <span>o</span>
            <span>f</span>
            <span> </span>
            <span>s</span>
            <span>p</span>
            <span>a</span>
            <br />
            <span>c</span>
            <span>e</span>
            <span> </span>
            <span>w</span>
            <span>i</span>
            <span>t</span>
            <span>h</span>
            <span> </span>
            <span>o</span>
            <span>u</span>
            <span>r</span>
            <span> </span>
            <br />
            <span>w</span>
            <span>e</span>
            <span>a</span>
            <span>p</span>
            <span>o</span>
            <span>n</span>
            <span>s</span>
            <span> </span>
            <span>a</span>
            <span>n</span>
            <span>d</span>
            <span> </span>
            <br />
            <span>a</span>
            <span>r</span>
            <span>m</span>
            <span>o</span>
            <span>r</span>
            </h3>
        </div>
      </div>
    )
}

export default Home